import React, { ComponentProps, useState } from 'react';
import { DefaultView, LazyView, Views } from '../../types/BlockWithViews';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { ModalDialogModifier } from '../../components/organisms/ModalDialog/ModalDialog';
import ModalDialog from '../../components/organisms/ModalDialog/ModalDialog';
import { BlockBar, BlockBarButton } from '../../_lib/components/BlockBar';
import { MostPopularPagesStatisticsView } from './views/MostPopularPagesStatisticsView';

type MostPopularPagesDefaultView = Record<string, never>;

type MostPopularPagesProps = Views<DefaultView<MostPopularPagesDefaultView> & { statistics: LazyView }>;

/**
 * Displays the most popular pages. The statistics are shown in a modal dialog.
 */
export function MostPopularPages({ views }: MostPopularPagesProps) {
  const { t } = useSonTranslation('MostPopularPages');
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const statisticsView = views?.statistics;
  const statisticsTranslation = t('statistics.title');

  if (!statisticsView) {
    return null;
  }

  return (
    <>
      <BlockBar heading={t('evaluation')} hierarchy={3}>
        <BlockBarButton onClick={() => setModalOpen(true)} svgSpriteId={Icons.ANALYSIS} text={statisticsTranslation} />
      </BlockBar>
      {modalOpen && (
        <ModalDialog
          modifier={ModalDialogModifier.WIDE}
          closeModal={() => setModalOpen(false)}
          headline={statisticsTranslation}
        >
          <MostPopularPagesStatisticsView {...statisticsView} />
        </ModalDialog>
      )}
    </>
  );
}

export const MostPopularPagesBlock = asBlock(MostPopularPages, BlockType.mostpopularpages);
export type MostPopularPagesBlock = ComponentProps<typeof MostPopularPagesBlock>;
